/**
 * Offerlist component.
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'library/fcse-dropdown/dropdown',
    'clientComponents/inlinemodal/inlineModal',
    'library/fcse-util/url',
    'library/fcse-util/paramConverter',
    'clientComponents/offervaliditycheck/offerValidityCheckButton',
    'clientComponents/alternatives/flightAlternatives',
    'clientComponents/oldoffer/oldOffer'
    ],
    function($, _, Object, OptionsMixin, EventDispatcher, Dropdown, InlineModal, Url, ParamConverter, OfferValidityCheckButton, FlightAlternatives, OldOffer) {

        var OfferList = function(element, requestHandler, scope, options) {
            EventDispatcher.apply(this, arguments);

            // Set default options
            var defaultOptions = {
                loadingClass: 'is-loading',
                topOfferIdSelector: '[data-fcse-top-offer-id]',
                topOfferClass: 'offerhorizontal-topoffer',
                isActiveClass: 'is-active',
                firstPageSelector: '[data-page="1"]'
            };

            // Store element
            this.element = $(element);

            // Save local variables
            this.requestHandler = requestHandler;
            this.scope = scope;
            this.initialRouteParams = $(element).data("initial-route-params");

            // Set additional params to local scope
            this.initialAdditionalParams = $(element).data("initial-additional-params");
            this.scope.setMultipleParams(this.initialAdditionalParams);

            this.addOptions(defaultOptions, options);
            this.topOfferId = $(this.option('topOfferIdSelector')).data('fcse-top-offer-id');

            this._init();
            this._initLoadingEvents();
        };

        OfferList.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin),{

            /**
             * The first element's ancestor selector to scroll on search running
             *
             * @type {String}
             */
            scrollToAncestorSelector: '[data-fcse-role="offerlist"]',

            /**
             *
             * @param e
             * @returns {boolean}
             * @private
             */
            _preventLink: function(e) {
                e.preventDefault();
                return false;
            },

            /**
             *
             * @param url
             * @param params
             * @private
             */
            _redirectPost: function(url, params) {
                var form = $('<form />').attr({'action': url, 'method': 'POST'});
                $.each(params, function( key, value ) {
                    form.append($('<input />').attr({'type': 'hidden', 'name': key, 'value': value}));
                });
                form.submit();
                document.body.appendChild(form[0]);
                form[0].submit();
            },
            /**
             * Initialize Offerlist
             *
             * @private
             */
            _init: function() {
                var self = this;

                this.defaultSorting = this.element.data('default-sorting') || 'price';
                // Initialize Sorting-Dropdown
                this.sortingDropdown = new Dropdown($('[data-widget-type="widget-sorting"]', this.element));
                this.sortingDropdown.on('change', $.proxy(this._onDropdownChange, this));

                // Initialize Limit-Dropdown
                this.limitDropdown = new Dropdown($('[data-widget-type="widget-resultsperpage"]', this.element));
                this.limitDropdown.on('change', $.proxy(this._onDropdownChange, this));

                // Initialize pagination
                $('[data-fcse-role="pagination"] [data-page]', this.element)
                    .off('click')
                    .on('click', $.proxy(this._onPaginationClick, this));

                // Create offer validity check buttons
                $('[data-fcse-role="check-offer-button"]', this.element).each(function(idx, elem){
                    var checkButton = new OfferValidityCheckButton(elem, self.requestHandler);
                });

                $('[data-fcse-role="scroll-to-offers"]')
                    .off('click')
                    .on('click', $.proxy(this._onTopOfferClick, this));
                // Disabled for now according to customer new requirements
                //this._updateTopOfferDisplay();

                if ($('[data-fcse-bookingtype="package"]').length) {
                    new OldOffer($('[data-fcse-role="offerlist"]'), self.requestHandler, {
                        oldPriceRoute: 'allt_old_price_offers.price'
                    });
                }

                // Create offer flight alternatives controls
                $('[data-fcse-role="flight-alternatives"]', this.element).each(function(idx, elem){
                    var flightAlternatives = new FlightAlternatives(elem, self.requestHandler, {
                            offersRoute: 'allt_frontend.package.detail.alternatives'
                        });
                });
            },

            /**
             * Initialize Loading Events
             *
             * @private
             */
            _initLoadingEvents: function() {
                // Register scope change handler
                this.scope.change($.proxy(this._onScopeChange, this));

                // Requesthandler loading events
                this.requestHandler.on('success', $.proxy(this._onLoadContentSuccess, this));
                this.requestHandler.on('error', $.proxy(this._onLoadContentError, this));
            },

            /**
             * Scope change handler
             *
             * @param scope
             * @param params
             * @private
             */
            _onScopeChange: function(scope, params) {
                // Reload offerlist
                this._loadContent();
            },

            /**
             * Click handler for pagination link
             * @param event
             * @private
             */
            _onPaginationClick: function(event){
                // Selected page
                var page = $(event.currentTarget).attr('data-page');

                // Load content
                this._loadContent({
                    sort: this.sortingDropdown.getValue(),
                    resultsPerPage: this.limitDropdown.getValue(),
                    page: page
                });
            },

            /**
             * Loads the content of the offerlist
             *
             * @private
             */
            _loadContent: function(additionalParams) {
                // Merge Parameters
                var params = $.extend(this.scope.getQuery(), additionalParams || {});

                // Set loading state
                $(this.element).addClass(this.option('loadingClass'));

                // Scrolling to top of offer list ALLINT-654
                if ($(this.element).closest(this.scrollToAncestorSelector).length) {
                    $('html,body').animate({scrollTop: $(this.element).closest(this.scrollToAncestorSelector).offset().top});
                }

                // Send request
                this.requestHandler.cancel(this.option('offersRoute'));
                this.requestHandler.send(this.option('offersRoute'), params, this.initialRouteParams);
            },

            /**
             * Handler for content loading success
             *
             * @param event
             * @param data
             * @param requestData
             * @protected
             */
            _onLoadContentSuccess: function(event, data, requestData) {
                // Check if ajax response is from offersRoute
                if (data.route !== this.option('offersRoute')) {
                    return;
                }

                // Unset loading state
                $(this.element).removeClass(this.option('loadingClass'));

                // Replace HTML content
                $(this.element).html(event.html);

                // Re-initialize offerlist
                this._init();
            },

            /**
             * Handler for content loading error
             * @param event
             * @private
             */
            _onLoadContentError: function(event) {
                console.log('Error handling');
            },

            /**
             * Dropdown Change Handler
             *
             * @private
             */
            _onDropdownChange: function() {
                this._loadContent({
                    sort: this.sortingDropdown.getValue(),
                    resultsPerPage: this.limitDropdown.getValue()
                });
            },

            /**
             * Sets top offer style for the equal offer in the list if exists
             * @private
             */
            _updateTopOfferDisplay: function() {
                var topListOffer = $('[data-fcse-role="offer-item"][data-offer-id="' + this.topOfferId + '"]', this.element);

                if (topListOffer.length) {
                    topListOffer.addClass(this.option('topOfferClass'));
                }
            },

            /**
             * Resets the sorting and paging to show the top offer in the list
             * @private
             */
            _onTopOfferClick: function() {
                if (this.sortingDropdown.getValue() !== this.defaultSorting ) {
                    this.sortingDropdown.setValue(this.defaultSorting);
                    return;
                }
                var firstPage = $('[data-fcse-role="pagination"] ' + this.option('firstPageSelector'), this.element);

                if (!firstPage.parent().hasClass(this.option('isActiveClass'))) {
                    firstPage.parent().addClass(this.option('isActiveClass'));
                    this._onPaginationClick({currentTarget: firstPage})
                }
            }
        });

        return OfferList;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/offerlist/offerList.js